// Menu router — currently the HTML <a href> tags do all the navigation work.
// This file is loaded so Vite recognizes the menu page as an entry point.
console.info("[flexy-protos] menu loaded");
export {};
